import React from 'react';
import { Container } from 'react-bootstrap';
import './ClientsSection.css';

// Import local client logos from assets/Clients
import logo1 from '../../assets/Clients/Logo1.png';
import logo2 from '../../assets/Clients/Logo2.png';
import logo3 from '../../assets/Clients/Logo3.png';
import logo4 from '../../assets/Clients/Logo4.png';
import logo5 from '../../assets/Clients/Logo5.png';
import logo6 from '../../assets/Clients/Logo6.png';
import logo7 from '../../assets/Clients/Logo7.png';
import logo8 from '../../assets/Clients/Logo8.png';
import logo9 from '../../assets/Clients/Logo9.png';
import logo10 from '../../assets/Clients/Logo10.png';
import logo11 from '../../assets/Clients/Logo11.png';
import logo12 from '../../assets/Clients/Logo12.png';
import logo13 from '../../assets/Clients/Logo13.png';
import logo14 from '../../assets/Clients/Logo14.png';
import logo15 from '../../assets/Clients/Logo15.png';
import logo16 from '../../assets/Clients/Logo16.png';
import logo17 from '../../assets/Clients/Logo17.png';
import logo18 from '../../assets/Clients/Logo18.png';
import logo19 from '../../assets/Clients/Logo19.png';
import logo20 from '../../assets/Clients/Logo20.png';

// 20 Client Logos (10 for Row 1, 10 for Row 2)
const row1Logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8, logo9, logo10];
const row2Logos = [logo11, logo12, logo13, logo14, logo15, logo16, logo17, logo18, logo19, logo20];

const ClientsSection = () => {
  return (
    <section className="clients-section-card-wrapper">
      <Container>
        <div className="clients-card-container">
          <p className="clients-card-title">
            Trusted Across Renewable Energy Ecosystems
          </p>

          <div className="clients-marquees-wrapper">
            {/* Row 1: Left to Right */}
            <div className="marquee-container">
              <div className="marquee-track marquee-track-left-to-right">
                {[...row1Logos, ...row1Logos].map((url, index) => (
                  <div className="marquee-item" key={`row1-${index}`}>
                    <img 
                      src={url} 
                      alt={`Client logo ${(index % 10) + 1}`} 
                      className="client-logo-img" 
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Row 2: Right to Left */}
            <div className="marquee-container">
              <div className="marquee-track marquee-track-right-to-left">
                {[...row2Logos, ...row2Logos].map((url, index) => (
                  <div className="marquee-item" key={`row2-${index}`}>
                    <img 
                      src={url} 
                      alt={`Client logo ${(index % 10) + 11}`} 
                      className="client-logo-img" 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </Container>
    </section>
  );
};

export default ClientsSection;